import { ReactNode } from 'react';

import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import { HeaderContent } from '@backrs_ui/common-ui/src/atoms/HeaderContent';

import { Box, Typography, Theme, SxProps } from '@mui/material';

type HeaderProps = Readonly<{
  title: string;
  secondaryTitle?: string;
  titleIcon?: string;
  middleSection?: ReactNode;
  rightSection?: ReactNode;
}>;

export const Header = ({
  title,
  secondaryTitle,
  titleIcon,
  middleSection,
  rightSection,
}: HeaderProps) => {
  return (
    <HeaderContent>
      <Box sx={containerStyle}>
        <Box sx={leftMiddleContainerStyle}>
          <Box sx={leftSectionStyle}>
            {titleIcon && <img src={titleIcon} style={logoStyle} alt={title} />}
            <Box sx={titleContainerStyle}>
              <Typography sx={titleStyle}>{title}</Typography>
              {secondaryTitle && <Typography sx={secondaryTitleStyle}>{secondaryTitle}</Typography>}
            </Box>
          </Box>
          {middleSection && <Box sx={middleSectionStyle}>{middleSection}</Box>}
        </Box>
        {rightSection && <Box sx={rightSectionStyle}>{rightSection}</Box>}
      </Box>
    </HeaderContent>
  );
};

const containerStyle: SxProps<Theme> = {
  width: '100%',
  padding: '10px 10px 0px 30px',
  borderRadius: '0px 0px 8px 8px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: 'auto',
  '@media (max-width: 1014px)': {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  '@media (max-width: 600px)': {
    padding: '5px 5px 5px 10px',
  },
};

const leftMiddleContainerStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: '45%',
  overflow: 'hidden',
  gap: '10px',
  '@media (max-width: 1014px)': {
    width: '100%',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
};

const titleContainerStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  gap: '5px',
  alignItems: 'center',
};

const titleStyle: SxProps<Theme> = {
  fontSize: '24px',
  fontWeight: 'bold',
  whiteSpace: 'nowrap',
  color: appColors.color.blue1,
};

const secondaryTitleStyle: SxProps<Theme> = {
  fontSize: '24px',
  color: appColors.color.blue1,
  whiteSpace: 'nowrap',
  fontWeight: '200',
};

const logoStyle = {
  width: '40px',
  height: '40px',
};

const leftSectionStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '10px',
  '@media (max-width: 900px)': {
    flexDirection: 'column',
  },
};

const middleSectionStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '10px',
  '@media (max-width: 900px)': {
    flexDirection: 'column',
  },
};

const rightSectionStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: '55%',
  gap: '10px',
  '@media (max-width: 1014px)': {
    width: '100%',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
};
